export default "__VITE_ASSET__b915cf98__"